<!------------------------------ Main Content ------------------------------>
<div class="table-content">
  <ng-container
    *ngIf="this.officesFull && this.officesFull.length > 0"
    ;else
    nodata
  >
    <!-------------------- Items -------------------->
    <div *ngFor="let office of this.officesFull">
      <div class="office-item-container">
        <!-- Name -->
        <div class="table-item" id="name">
          <p class="paragraph-01-regular">{{ office.name }}</p>
        </div>

        <!-- Region -->
        <div class="table-item" id="region">
          <p class="paragraph-01-regular">{{ office.region }}</p>
        </div>

        <!-- Version -->
        <div class="table-item" id="version">
          <p class="paragraph-01-regular">{{ office.version }}</p>
        </div>

        <!---------- Menu & Options ---------->
        <div class="options-item" id="remax_office_id">
          <!-- Open Menu -->
          <mat-checkbox
            [checked]="office.checked"
            color="primary"
            (change)="checkboxChange(office, $event.checked)"
            >
          </mat-checkbox>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #nodata>
  <p>No hay datos</p>
</ng-template>
